import React from "react";
import { ColorPalette } from "../../types/background";
import {
  getColorClasses,
  getTextColorClass,
} from "../../utils/getBackgroundColor";
import classNames from "classnames";
import dayjs from "dayjs";
import Link from "../Link/Link";

export interface TeaserCardProps {
  title: string;
  backgroundColor: ColorPalette;
  tag: string;
  created: string;
  hideImage: boolean;
  href: string;
  image?: string;
  linkText?: string;
}

const getButtonType = (backgroundColor: TeaserCardProps["backgroundColor"]) => {
  switch (backgroundColor) {
    case "white":
    case "secondaryYellow":
    case "primaryBlue":
    case "secondaryGreen":
    case "secondaryLightGreen":
      return "link-secondary";
    case "primary":
    case "primaryTurquoise":
    case "secondaryDarkGreen":
      return "link-secondary-reverse";
  }
};

const getHeadingSize = (text: string, image?: boolean) => {
  return image
    ? text.length > 100
      ? "text-1xl"
      : "text-2xl"
    : text.length > 50
    ? "text-2xl"
    : "text-3xl";
};

export const TeaserCard = ({
  title,
  backgroundColor,
  tag,
  created,
  hideImage,
  href,
  image,
  linkText,
}: TeaserCardProps) => {
  const showImage = !hideImage && !!image;
  const buttonType = getButtonType(backgroundColor);
  const headingSize = getHeadingSize(title, showImage);
  const backgroundClass = getColorClasses(backgroundColor);
  const textClass = getTextColorClass(backgroundColor);

  return (
    <div
      className={classNames(
        "rounded pt-8 min-w-fit flex flex-col justify-between",
        backgroundClass,
        showImage ? "min-h-[534px]" : "min-h-[500px]"
      )}
    >
      <div className={classNames(backgroundClass)}>
        {!!tag && (
          <div className="px-5 md:px-9">
            <div className="inline-block py-1 px-2 rounded bg-secondaryYellowLight">
              <p className="text-xs text-primary">{tag}</p>
            </div>
          </div>
        )}

        <h3
          className={classNames(
            "text-2xl px-5 md:px-9 font-serif",
            textClass,
            headingSize,
            showImage ? "mt-4" : "mt-52"
          )}
        >
          {title}
        </h3>
      </div>

      <div>
        <div className="text-sm text-gray-400 px-5 md:px-9">
          <Link
            text={linkText || dayjs(created).format("DD. MMMM YYYY")}
            variant={buttonType}
            className={classNames("text-left", showImage ? "" : "mb-10", "cursor-pointer", "justify-start")}
            href={href}
          />
        </div>

        {showImage && (
          <img
            alt={title}
            src={image}
            className="w-full rounded-b object-cover mt-8"
            style={{ height: "224px" }}
          />
        )}
      </div>
    </div>
  );
};
